<div class="wk8-book-contents-canvas-component" style="height: 100%; align-content: center">
  <wk8-book-contents [book]="comp().book" mode="LEVEL_SELECT" [onStartLevel]="comp().onStartLevel" style="pointer-events: all" />
</div>
